export const COPILOT_LAST_OPEN = 'copilot-last-open';